import React from 'react'
import './LayerOptionsOpener.scss'
const LayerOptionsOpener = ({active}) => {

    return (
    <div className={active ? 'layer-options-opener active' : 'layer-options-opener'}>&equiv;</div> 
    )
    
}
export default LayerOptionsOpener